import React, { useMemo } from 'react'
import Cluster from './Cluster'
import { Divider, Empty, Flex, Spin } from 'antd'
import { connect } from 'react-redux'
import { CLUSTER_X_ID, CLUSTER_Y_ID } from '../../../../constants/cluster-ids'
import useClusterGroups from './useClusterGroups'
// Removed auto-collapse hook here to avoid re-collapsing after user expands

const ClusterGroup = ({
    isWaitingForClusters,
    isWaitingForAssignmentInfo,
    isWaitingForFiles,
    isWaitingForPatterns,
    isWaitingForSelectSubgroup,
}) => {
    const { clusters: filteredClusters } = useClusterGroups({ applyFilter: true })


    const clusterBlocks = useMemo(() => {
        const clusterX = filteredClusters.find(cluster => cluster?.cluster_id === CLUSTER_X_ID)
        const clusterY = filteredClusters.find(cluster => cluster?.cluster_id === CLUSTER_Y_ID)
        const regularClusters = filteredClusters.filter(
            cluster => cluster?.cluster_id !== CLUSTER_X_ID && cluster?.cluster_id !== CLUSTER_Y_ID,
        )

        const clusterComponents = [...regularClusters, clusterX, clusterY]
            .filter(Boolean)
            .map(cluster => <Cluster key={cluster.cluster_id} cluster={cluster} />)

        if (clusterComponents.length > 2 && clusterX && clusterY) {
            clusterComponents.splice(clusterComponents.length - 2, 0, <Divider key='divider' />)
        }

        return clusterComponents
    }, [filteredClusters])

    let loadingMessage
    if (isWaitingForAssignmentInfo) {
        loadingMessage = 'Loading assignment...'
    } else if (isWaitingForClusters) {
        loadingMessage = 'Loading groups...'
    } else if (isWaitingForPatterns) {
        loadingMessage = 'Loading patterns...'
    } else if (isWaitingForFiles) {
        loadingMessage = 'Loading files...'
    } else if (isWaitingForSelectSubgroup) {
        loadingMessage = 'Looking for subgroups...'
    }

    let clusters

    if (clusterBlocks.length) {
        clusters = clusterBlocks
    } else {
        clusters = (
            <div className='d-flex-center' style={{ height: '50vh' }}>
                {!loadingMessage ? <Empty description='There are no groups' /> : null}
            </div>
        )
    }

    return (
        <Spin wrapperClassName='clusters__container' spinning={Boolean(loadingMessage)} tip={loadingMessage}>
            <Flex gap={16} vertical>
                {clusters}
            </Flex>
        </Spin>
    )
}

const mapState = ({ assignment }) => {
    return {
        isWaitingForClusters: assignment.isWaitingForClusters,
        isWaitingForAssignmentInfo: assignment.isWaitingForAssignmentInfo,
        isWaitingForFiles: assignment.isWaitingForFiles,
        isWaitingForPatterns: assignment.isWaitingForPatterns,
        isWaitingForSelectSubgroup: assignment.isWaitingForSelectSubgroup,
    }
}

const mapDispatch = {}

export default connect(mapState, mapDispatch)(ClusterGroup)
